import { Box, Column, Row, Text } from '~/commonComponents';
import { IPostingPlanViewEntity } from '~/domain/PermanentJobs';
import { CheckSingleIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';
import { formatListingFee } from '~/components/PermanentJobsV2/utils';

interface IHiringPlanCardProps {
  plan?: IPostingPlanViewEntity;
}

export const HiringPlanCard = ({ plan }: IHiringPlanCardProps) => {
  const price = plan?.finalPrice ? formatListingFee(plan.finalPrice) : '-';

  return (
    <Box
      border={`1.5px solid ${Colors.neutral_100}`}
      borderRadius={8}
      backgroundColor={Colors.white}
      paddingBlock={24}
      paddingInline={66}
      gap={16}
    >
      <Text bold color={Colors.neutral_600} fontSize={24}>
        Your Hiring Plan
      </Text>

      <Column gap={14}>
        <Row gap={3}>
          <CheckSingleIcon color={Colors.secondary_500} />
          <Column>
            <Text color={Colors.neutral_600}>
              <Text bold>Every applicant is pre-screened.</Text> No sorting through unqualified
              resumes.
            </Text>
          </Column>
        </Row>
        <Row gap={3}>
          <CheckSingleIcon color={Colors.secondary_500} />
          <Column>
            <Text color={Colors.neutral_600}>
              <Text bold>No scheduling headaches.</Text> Candidates pick their own interview slots
              and just show up.
            </Text>
          </Column>
        </Row>
        <Row gap={3}>
          <CheckSingleIcon color={Colors.secondary_500} />
          <Column>
            <Text color={Colors.neutral_600}>
              <Text bold>Tap into GoTu&apos;s active network.</Text> Reach candidates who
              aren&apos;t browsing job boards.
            </Text>
          </Column>
        </Row>
      </Column>

      <Box
        paddingTop={22}
        paddingBottom={32}
        paddingHorizontal={25}
        borderRadius={10}
        backgroundColor={Colors.white}
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.15)"
      >
        <Text fontSize={18} bold color={Colors.neutral_600}>
          Job Listing Fee
        </Text>
        <Text fontSize={14} color="neutral_500">
          <Text fontSize={36} bold color="neutral_600">
            ${price}
          </Text>{' '}
          /monthly
        </Text>
        <Text fontSize={15} bold color={Colors.primary_500} marginTop={10}>
          Your job will immediately become active and notify nearby candidates.
        </Text>
      </Box>
    </Box>
  );
};
